import Calendar from '@app/components/Calendar'
import {
  CalendarLegend,
  CalendarLegendEntry,
} from '@app/components/CalendarLegend'
import { ICurrentUserState } from '@app/store/modules/account'
import { convertToWebcalUrl } from '@app/utils/calendar'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Form, FormGroup, Input, Label } from 'reactstrap'
import {
  actionCreators,
  BrokeragePipelinesCalendarScope,
  IBrokeragePipelinesCalendarState,
} from '../modules/brokeragePipelinesCalendar'

type BrokeragePipelinesCalendarProps = IBrokeragePipelinesCalendarState &
  typeof actionCreators &
  ICurrentUserState

export class BrokeragePipelinesCalendar extends React.PureComponent<
  BrokeragePipelinesCalendarProps
> {
  constructor(props: BrokeragePipelinesCalendarProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title='Brokerage Pipelines Calendar'>
        <div className='h-100 d-flex flex-column p-3'>
          <div className='d-flex justify-content-between'>
            <div>
              <h4>Brokerage Pipelines</h4>
            </div>
            {this.props.user && this.props.user.permissions.isAdmin && (
              <Form inline>
                <FormGroup>
                  <Label className='mr-2'>View</Label>
                  <Input
                    bsSize='sm'
                    onChange={this._onScopeChanged}
                    type='select'
                    value={this.props.scope}
                  >
                    <option value={BrokeragePipelinesCalendarScope.All}>
                      All brokerage pipelines
                    </option>
                    <option value={BrokeragePipelinesCalendarScope.Mine}>
                      Only my brokerage pipelines
                    </option>
                  </Input>
                </FormGroup>
              </Form>
            )}
          </div>
          <Calendar
            containerClassName='flex-grow-1 my-2'
            events={this.props.events}
            onDateRangeChanged={this.props.loadEvents}
          />
          <div className='d-flex justify-content-between'>
            <div>
              <a
                href={convertToWebcalUrl(this.props.downloadUrl)}
                target='_blank'
                rel='noreferrer'
              >
                Sync with your calendar
              </a>
            </div>
            <div>
              <CalendarLegend>
                <CalendarLegendEntry
                  entryKey='event-assignment'
                  entryDescription='Assigned to me'
                />
                <CalendarLegendEntry
                  entryKey='event-assigned-by-me'
                  entryDescription='Created by me'
                />
                <CalendarLegendEntry
                  entryKey='event-brokerage-pipeline-closing'
                  entryDescription='Closing date'
                />
                <CalendarLegendEntry
                  entryKey='event-other'
                  entryDescription='Other critical date'
                />
              </CalendarLegend>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _onScopeChanged(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setScope(event.target.value as BrokeragePipelinesCalendarScope)
    this.props.loadEvents(this.props.startTime, this.props.endTime)
  }
}
